module.exports = __webpack_public_path__ + "static/img/6.fa5b66f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/6.png
// module id = 0eFo
// module chunks = 2